const STORE_NAME = 'detail';

export default {
    name: STORE_NAME,
    namespaced: true,
    state: {
        configDataBeforeShow: null,
        show: false,
    },
    mutations: {
        setConfigDataBeforeShow(state, configDataBeforeShow) {
            state.configDataBeforeShow = configDataBeforeShow;
        },
        setVisibility(state, show) {
            state.show = show;
        },
        clear(state) {
            state.show = false;
            state.configDataBeforeShow = null;
        },
    },
    getters: {
        configDataBeforeShow: (state) => state.configDataBeforeShow,
        isVisible: (state) => state.show,
    },
    actions: {
        setConfigDataBeforeShow({ commit }, config) {
            commit('setConfigDataBeforeShow', config);
        },
        setVisibility({ commit }, show) {
            commit('setVisibility', show);
        },
        clear({ commit }) {
            commit('clear');
        },
    },
};
